export type ImpactAudience = 'admins' | 'users' | 'everyone';

export interface WhatsNewTypeOption {
	whatsNewTypeId: number;
	typeName: string;
	typeDescription: string;
	displayOrder: number;
}

export interface WhatsNewUpdateApiRow {
	whatsNewId: number;
	versionName: string;
	title: string;
	whatsNewType: number;
	impactLabel: string;
	screenshotCount: number;
	releaseDate: string;
}

export interface WhatsNewDocumentRequest {
	documentId: number;
	documentModuleId: number;
	moduleDetailsId: number;
	uploadFileName: string;
	filePath: string;
	storageFileName: string;
}

export interface WhatsNewEntity {
	whatsNewId: number;
	versionId: number;
	title: string;
	description: string;
	whatsNewType: number;
	whatsNewListType: number;
	impactType: number;
	isAdminImpacted: boolean;
	isUserImpacted: boolean;
	releaseDate: string;
	isPublished: boolean;
	documentRequests?: WhatsNewDocumentRequest[];
	documentList?: WhatsNewDocumentRequest[];
}

export interface UpdateRow {
	id: number;
	title: string;
	typeId: number;
	typeName: string;
	impacts: string;
	version: string;
	released: string;
	screensCount: number;
}

export const TYPE_PILL_SLUG: Record<string, string> = {
	'New Feature': 'newFeature',
	Improved: 'improved',
	Fixed: 'fixed',
	Security: 'security',
};

export interface RoadmapRow {
	id: number;
	title: string;
	status: string;
	target: string;
	impacts: string;
}

export const STATUS_PILL_SLUG: Record<string, string> = {
	Published: 'completed',
	Planned: 'planned',
};

export interface TargetQuarterOption {
	quarterId: number;
	quarterName: string;
}

export interface VersionOption {
	oneGuruVersionId: number;
	version: string;
}

export interface WhatsNewComingNextApiRow {
	oneGuruComingNextId: number;
	title: string;
	description: string;
	targetQuarter: number;
	targetQuarterName: string;
	impactType: number;
	isAdminImpacted: boolean;
	isUserImpacted: boolean;
	impactLabel: string;
	isPublished: boolean;
	publishedOn: string | null;
}
